import Axios from "../../Config/API";
import {
    IExtrato,
    IExtratoIR,
    IExtratoViaContaResponse,
} from "../../../Interfaces/Cobranca/Extrato/ExtratoInterface";
import Service from "../../Service";

export async function BaixarExtratoPDFService(requestBody: IExtrato) {
    return Service(
        Axios.post<string>(`/cobranca/extrato/baixarextratopdf`, requestBody)
    );
}

export async function BaixarExtratoPDFViaContaService(
    requestBody: IExtrato,
    ID_CONTA: number,
    idTipoCaso: number,
    ID_CASO: number
) {
    return Service(
        Axios.post<IExtratoViaContaResponse>(
            `/cobranca/extrato/gerarextratoviaconta?ID_CONTA=${ID_CONTA}&idTipoCaso=${idTipoCaso}`,
            requestBody
        )
    );
}

export async function BaixarExtratoIrpfPDFService(requestBody: IExtratoIR) {
    return Service(
        Axios.post(`/cobranca/extrato/baixarextratoirpfpdf`, requestBody)
    );
}
